__turbopack_context__.v({
  "electric-blue-disclaimer-link": "translated-text-visid-module-scss-module__q3z6Dq__electric-blue-disclaimer-link",
  "electric-blue-disclaimer-link-no-underline": "translated-text-visid-module-scss-module__q3z6Dq__electric-blue-disclaimer-link-no-underline",
});
